import { css } from '@/styled-system/css';

export const mapBorderTooltipStyles = css({
  background: 'hpxBlue500',
  color: 'hpxWhite',
  width: '126px',
  height: '26px',
  borderRadius: '4px',
  padding: 'xs',
  position: 'fixed',
  fontSize: 'tiny',
  fontWeight: 700,
  lineHeight: 'sm',
  textAlign: 'center',
  zIndex: 'zIndexStepOver',
  pointerEvents: 'none',
  _after: {
    content: '" "',
    position: 'absolute',
    right: '100%',
    top: '50%',
    borderStyle: 'solid',
    borderColor: 'transparent',
    height: 0,
    width: 0,
    pointerEvents: 'none',
    borderRightColor: 'hpxBlue500',
    borderWidth: '6px',
    marginTop: '-6px',
  },
});
